import {
  Alert,
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import React from 'react';

interface SubProduct {
  id: string;
  name: string;
}

interface SubProductSelectorProps {
  subProducts: SubProduct[];
  selectedSubProduct: string;
  onSelectSubProduct: (id: string) => void;
  onViewDocuments: (id?: string) => void | Promise<void>;
  showCreditLineWarning?: boolean;
}

const SubProductSelector: React.FC<SubProductSelectorProps> = ({
  subProducts,
  selectedSubProduct,
  onSelectSubProduct,
  onViewDocuments,
  showCreditLineWarning = false,
}) => {
  const handleChange = (event: SelectChangeEvent) => {
    const value = event.target.value;
    onSelectSubProduct(value);
    if (value) {
      void onViewDocuments(value);
    }
  };

  if (subProducts.length === 0) {
    return (
      <Alert severity="warning" sx={{ mt: 2 }}>
        Este cliente no tiene subproductos disponibles para factorizar. Por
        favor revise si su línea de crédito está activa
      </Alert>
    );
  }

  return (
    <Box sx={{ mt: 2 }}>
      {showCreditLineWarning && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          La operación se generará sin comprobación de línea de crédito, según
          la configuración actual.
        </Alert>
      )}

      <FormControl fullWidth>
        <InputLabel id="subproduct-label">Subproducto</InputLabel>
        <Select
          labelId="subproduct-label"
          id="subproduct-select"
          value={selectedSubProduct || ''}
          onChange={handleChange}
          label="Subproducto"
        >
          {subProducts.map((subProduct) => (
            <MenuItem key={subProduct.id} value={subProduct.id}>
              {subProduct.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default SubProductSelector;
